var client = {};
export {
  client as __exports
};
//# sourceMappingURL=client2.js.map
